import React from 'react';
import { Table } from 'antd';
import styled from 'styled-components';
import { useQuery } from 'react-query';

import { ApiClient } from '../../api';
import { DrawerLayout } from '../../Layout';
import { paginationStyles } from '../common';
import { columns } from './data';
import style from './styles';

const SubscribersWrapper = styled.div`
    ${style}
    ${paginationStyles}
`;

const SubscribersComponent = () => {
    const { isFetching, data } = useQuery('subscription-subscribers', ApiClient.getSubscriptionSubscribers, {
        refetchOnWindowFocus: false,
    });
    const subscribers = data?.subscribers ?? [];

    return (
        <DrawerLayout>
            <SubscribersWrapper>
                <div className={'header'}>
                    <div className="flex-1" />
                    <div className="subscriber-count">Current Subscribers: {subscribers.length}</div>
                </div>
                <Table
                    loading={isFetching}
                    rowKey={(record: any) => `${record.userId}-${record?.subscription?.id || 'subscription'}`}
                    columns={columns}
                    dataSource={subscribers}
                    locale={{ emptyText: 'No Subscribers' }}
                    scroll={{ x: true }}
                />
            </SubscribersWrapper>
        </DrawerLayout>
    );
};

export default SubscribersComponent;
